import { UserDetails } from '@pages/Home/types';
import axiosClient from './axios-client'; // Import the axiosClient instance'..


const Home_Dashboard_URL = '/Home/Dashboard';
const User_Details_URL = '/Home/UserDetails';


export const getHomeData = async () => {
  try {
    const response = await axiosClient.get(Home_Dashboard_URL); // Make the GET request
    return response; // Since axiosClient interceptor is already handling the response
  } catch (error) {
    console.error('Error fetching home data:', error); // Log error for debugging
    throw error; // Propagate error if any
  }
};

// New function for fetching user details using axiosClient
export const getUserDetails = async (): Promise<UserDetails> => {
  try {
    const response = await axiosClient.get(User_Details_URL);
    return response as unknown as UserDetails;  // Cast to expected type
  } catch (error) {
    console.error('Error fetching user details:', error);
    throw error;
  }
};